"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeItemChildren = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var tree_view_context_1 = require("../../tree-view/tree-view-context");
function TreeItemChildren(_a) {
    var getCollapseProps = _a.getCollapseProps, children = _a.children;
    var toggleButtonOptions = (0, tree_view_context_1.useTreeView)().toggleButtonOptions;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledBody, (0, tslib_1.__assign)({ paddingLeft: toggleButtonOptions.width }, getCollapseProps()), children)));
}
exports.TreeItemChildren = TreeItemChildren;
var StyledBody = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  overflow: hidden;\n  padding-left: ", "px;\n  flex-grow: 1;\n"], ["\n  overflow: hidden;\n  padding-left: ", "px;\n  flex-grow: 1;\n"])), function (_a) {
    var paddingLeft = _a.paddingLeft;
    return paddingLeft;
});
var templateObject_1;
//# sourceMappingURL=tree-item-children.js.map